<div class="container-box shadow-none" style="background: #fbfbff">
  <div class="p-3">
    <div class="card">
      <div class="filters-box">
        <app-select-search
          class="w-auto"
          matTooltip="Only show rentals that specify the selected cities."
          matTooltipPosition="above"
          i18n-matTooltip
          id="rentals-filters-cities"
          [items]="cities$ | async"
          [ctrl]="citiesCtrl"
          placeholder="Rentals by Cities"
          i18n-placeholder
        ></app-select-search>
        <app-select-search
          class="w-auto"
          matTooltip="Only show rentals that specify the selected tags."
          matTooltipPosition="above"
          i18n-matTooltip
          id="rentals-filters-tags"
          [items]="tags$ | async"
          [ctrl]="tagsCtrl"
          placeholder="Rentals by Tags"
          i18n-placeholder
        ></app-select-search>
        <mat-form-field2 [showLabel]="false" class="w-auto">
          <mat-select [formControl]="statusCtrl" placeholder="Connection Status" i18n-placeholder>
            <mat-option value="all" i18n>All</mat-option>
            <mat-option value="active" i18n>Active</mat-option>
            <mat-option value="inactive" i18n>Inactive</mat-option>
          </mat-select>
        </mat-form-field2>

        <app-cancel-filters
          [isFiltering]="isFiltering"
          (clear)="onCancelFilters()"
          [searchCom]="search"
        ></app-cancel-filters>
        <button class="btn btn-secondary-primary" (click)="onRefresh()" matTooltip="Refresh List" i18n-matTooltip>
          <i class="far fa-sync"></i>
        </button>
        <div class="flex-fill"></div>
        <app-table-search (search)="searchCtrl.setValue($event)" #search></app-table-search>
      </div>
      <div class="table-holder table-responsive">
        <table class="table table-default table-striped">
          <mat-table #table matSort [dataSource]="dataSource" multiTemplateDataRows>
            <ng-container matColumnDef="rental_name">
              <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Linked Rental</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div class="text-truncate mr-2">
                  {{ element.rental_name }}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cancellationPolicyType">
              <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Cancellation Policy Type</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="status-line">{{ element.cancellationPolicyType }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="displayNameStateText">
              <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Display Name State</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="status-line">{{ element.displayNameStateText }}</span>
                <i
                  class="fa fa-info-circle"
                  *ngIf="!!element.displayNameRejectionReasons"
                  [matTooltip]="element.displayNameRejectionReasons"
                  matTooltipPosition="above"
                ></i>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="iconStateText">
              <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Icon State</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="status-line">{{ element.iconStateText }}</span>
                <i
                  class="fa fa-info-circle"
                  *ngIf="!!element.iconRejectionReasons"
                  [matTooltip]="element.iconRejectionReasons"
                  matTooltipPosition="above"
                ></i>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="statusView">
              <mat-header-cell *matHeaderCellDef mat-sort-header i18n> status</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="status-line" [matTooltip]="element.statusTooltip">{{
                  element.statusView | titleCase
                }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef i18n> action</mat-header-cell>
              <mat-cell *matCellDef="let element" class="d-flex gap-2">
                <app-form-switch
                  *ngIf="element.active"
                  [matTooltip]="
                    element.active
                      ? 'Deactivate listing on Google Vacation Rentals'
                      : 'Activate listing on Google Vacation Rentals'
                  "
                  matTooltipPosition="above"
                  i18n-matTooltip
                  [disabled]="element.detailRow"
                  (click)="$event.stopPropagation()"
                  [id]="element.id"
                  [inline]="true"
                  [value]="element.active"
                  (valueChange)="onToggleStatus(element)"
                ></app-form-switch>

                <button
                  (click)="onEditListing(element)"
                  class="btn btn-secondary-danger btn-sm"
                  type="button"
                  style="min-width: auto"
                >
                  <ng-container i18n *ngIf="element.websiteProvider">Edit</ng-container>
                  <ng-container i18n *ngIf="!element.websiteProvider">Activate</ng-container>
                </button>

                <button
                  *ngIf="element.detailRow"
                  (click)="setExpanded(expandedElement?.rentalId === element.rentalId ? null : element)"
                  class="btn btn-sm btn-secondary-info"
                  type="button"
                  i18n
                >
                  Fix
                </button>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <mat-cell *matCellDef="let detail" class="p-0 bg-white">
                <div class="validation-list">
                  <div *ngFor="let error of validations[detail.rentalId]" class="invalid-item">
                    <i class="fas fa-exclamation-circle" [ngClass]="error.type"></i>
                    <ng-container *ngFor="let e of error.errors">{{ e }}</ng-container>
                    <div class="flex-fill"></div>
                    <button (click)="onFixRental(detail, error)" type="button" class="btn btn-sm btn-secondary-info">
                      <ng-container i18n>fix it</ng-container> <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
                    </button>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              [ngClass]="{ expanded: expandedElement?.rentalId == row.rentalId, 'row-danger': row.hasError }"
              class="element-row"
            >
            </mat-row>

            <mat-row
              *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow"
              [ngClass]="{ 'empty-cell': validations[row?.rental?.id]?.length === 0 }"
              [@detailExpand]="row?.rentalId == expandedElement?.rentalId ? 'expanded' : 'collapsed'"
              style="overflow: hidden"
            >
            </mat-row>
          </mat-table>

          <ng-container *ngIf="(validationsLoaded$ | async) && (isEmptyTable$ | async)">
            <div class="p-4 text-center" i18n>You haven't created any rentals on your account yet</div>
          </ng-container>
          <app-loading-section *ngIf="!(validationsLoaded$ | async)"></app-loading-section>

          <mat-paginator2
            #paginator
            [class.hidden]="isEmptyTable$ | async"
            [length]="dataSource?.data?.length"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
            [showFirstLastButtons]="true"
          >
          </mat-paginator2>
        </table>
      </div>
    </div>
  </div>
  <div class="border-top p-4 mt-4 d-flex align-items-center gap-3">
    <button class="btn btn-outline-light" (click)="prev.emit()">
      <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
      <ng-container i18n>Previous</ng-container>
    </button>
    <div class="flex-fill"></div>
    <button (click)="onBookingFormula()" [disabled]="1 | isReadonlyRole" type="button" class="btn btn-secondary-info">
      <span class="cs-icon cs-icon-calendar-cog"></span>
      <ng-container i18n>Set Booking Formula</ng-container>
    </button>

    <button (click)="onComplete()" type="button" class="btn btn-secondary-success">
      <ng-container i18n>Complete</ng-container> <i class="fas fa-check"></i>
    </button>
  </div>
</div>
